import Vue from "vue";
import errors from "./errors";
import mixins from "./global_mixins";

let components = {
  uChat: () => import("../components/chat"),
  uPhotoUpload: () => import("../components/core/UPhotoUpload"),
  uCreateWorkshop: () => import("../components/core/UCreateWorkshop"),
  uChangePassword: () => import("../components/core/UPasswordChange"),
  ubtn: () => import("../components/core/UButton"),
  uBtnB: () => import("../components/core/UButtonB"),
  uBtnOutlined: () => import("../components/core/UButton"),
  uinput: () => import("../components/core/UInput"),
  uinput2: () => import("../components/core/UInput2"),
  ulabel: () => import("../components/core/ULabel"),
  uform: () => import("../components/core/UForm"),
  uselect: () => import("../components/core/UGroupSelect"),
  uhero: () => import("../components/core/UHero"),
  uNavWrap: () => import("../components/core/UNavWrap"),
  unav: () => import("../components/core/UNavbar"),
  usearch: () => import("../components/core/USearch"),
  uCourseCard: () => import("../components/core/UCourseCard"),
  uCardList: () => import("../components/core/UCardList"),
  uWorkshopCard: () => import("../components/core/UWCard"),
  uCardUser: () => import("../components/core/UWCProfile"),
  uTestimonials: () => import("../components/core/UTestimonials"),
  uSplit: () => import("../components/core/USplit"),
  uFaq: () => import("../components/core/UFaq"),
  uBtnA: () => import("../components/core/UButtonA"),
  uCoursesUpcoming: () => import("../components/core/UCoursesHome"),
  uLoader: () => import("../components/core/ULoader"),
  uStepper: () => import("../components/Stepper"),
  uModal: () => import("../components/core/UModal"),
  uLiveIcon: () => import("../components/core/ULiveIcon"),
  uCustomSelect: () => import("../components/core/USelect"),
  uSingleSelect: () => import("../components/core/USingleSelect"),
  uFeedback: () => import("../components/core/UFeedbackForm"),
  uVideo: () => import("../components/core/UVideo"),
  uPane: () => import("../components/core/USplitModal"),
  uListRes: () => import("../components/core/UList3C"),
  trainerTimer: () => import("../components/core/TrainerWorkShopTimer")
};

export default {
  register: () => {
    Object.keys(components).forEach(i => {
      Vue.component(i, components[i]);
    });
    Vue.mixin(mixins);
  },
  errors
};
